import type { OrgTestRunsListParams } from '../../types/controlTestRun.ts';

const controlTestingRoot = ['control-testing'] as const;

export const queryKeys = {
  controlTesting: {
    all: controlTestingRoot,
    testRuns: {
      /** The org-wide Test Runs page. Shares the 'test-runs' prefix with byControl so one invalidation refreshes both. */
      org: (params: OrgTestRunsListParams) =>
        [...controlTestingRoot, 'test-runs', 'org', params] as const,
      byControl: (controlUuid: string, auditYearId?: string | null) =>
        [...controlTestingRoot, 'test-runs', 'control', controlUuid, auditYearId ?? ''] as const,
    },
    runActivityLog: (runId: string) =>
      [...controlTestingRoot, 'run-activity-log', runId] as const,
    runRawCalls: (runId: string) =>
      [...controlTestingRoot, 'run-raw-calls', runId] as const,
  },
} as const;
